import React, {Component} from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

import find from "lodash/find";

import {ROLE_ADMIN, ROLE_SUPER_ADMIN} from '../auth/Auth';

interface ModalAddDashboardProps {
  show: boolean,
    onHandleClose: Function,
    onCreateDashboard: Function,
    orgs: any,
    currentUser: any,
}

interface ModalAddDashboardStage {
  name: string,
    org_id: string,
    errors: any
}

class ModalAddDashboard extends Component<ModalAddDashboardProps, ModalAddDashboardStage> {
  constructor(props: any) {
    super(props);

    this.handleAddDashboard = this.handleAddDashboard.bind(this);
    this.handleFormChangeInput = this.handleFormChangeInput.bind(this);
    this.handleFormChangeSelect = this.handleFormChangeSelect.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      name: '',
      org_id: props.currentUser ? props.currentUser.orgId : 0,
      errors: []
    };
  }

  resetState() {
    const {currentUser} = this.props;
    this.setState({
      name: '',
      org_id: currentUser ? currentUser.orgId : 0
    });
  }

  showErrors() {
    const { errors } = this.state;

    if (!errors || errors.length === 0) {
      return '';
    }

    const errorsElements = errors.map((error:any, idx:number) => {
      return (
        <Alert key={idx} variant="danger">
          {error.message}
        </Alert>
      );
    });

    return errorsElements;
  }

  checkValueTypeHasError(type:string) {
    const { errors } = this.state;
    if (!errors || errors.length === 0 ) {
      return false;
    }

    const errorFound = find(errors, (error:any) =>
      error.type === type
    );

    if (errorFound) {
      return true;
    }
    return false;
  }

  handleClose() {
    const { onHandleClose } = this.props;
    this.resetState();
    onHandleClose();
  }

  handleFormChangeSelect(event: any) {
    event.persist();
    this.setState((prevState:any) => ({
      ...prevState,
      [event.target.name as string]: event.target.value,
    }));
  }

  handleFormChangeInput(event: any) {
    let value = event.target.value;
    let name = event.target.name;
    this.setState((prevState:any) => ({
      ...prevState,
      [name as string]: value,
    }));
  }

  async handleAddDashboard(event:any) {
    const { name, org_id } = this.state;
    const newErrors = [];

    event.preventDefault();
    event.stopPropagation();

    // Check to see if things are setup correctly
    // Name must be set
    if (name.trim().length === 0 ) {
      newErrors.push({
        type: 'name',
        message: 'Please enter a dashboard name.'
      });
    }

    // Name is limited to 64 characters
    if (name.trim().length > 64 ) {
      newErrors.push({
        type: 'name',
        message: 'Please enter a title less than 64 characters.'
      });
    }

    // No org id was selected
    if (org_id.trim().length === 0 ) {
      newErrors.push({
        type: 'org_id',
        message: 'Please select an organization id.'
      });
    }

    this.setState({errors: newErrors});

    if (newErrors.length === 0) {
      await this.props.onCreateDashboard({
        name: name,
        org_id: org_id
      });
      await this.props.onHandleClose();
      this.resetState();
    }
  }

  renderOrgSelect() {
    const { orgs, currentUser } = this.props;
    const { org_id } = this.state;

    if (!orgs || !Array.isArray(orgs)) {
      return <div></div>;
    }

    let orgsSelectOptions;
    if (currentUser) {
      if ([ROLE_ADMIN, ROLE_SUPER_ADMIN].includes(currentUser.roleId)) {
        orgsSelectOptions = orgs.map((org:any) => {
          return <option key={`addmodalorgid-${org.id}`} value={org.id}>{org.name}</option>
        });
      } else {
        orgsSelectOptions = <option key={`addmodalorgid-${currentUser.orgId}`} value={currentUser.orgId}>{currentUser.orgName}</option>
      }
    }

    return (
      <Form.Group>
        <Form.Label>Organization</Form.Label>
        <Form.Control
          as="select"
          value={org_id}
          className="form-control"
          name="org_id"
          id="dashboard-orgid"
          isInvalid={this.checkValueTypeHasError('org_id')}
          onChange={this.handleFormChangeSelect}
        >
          <option value="0">Select an Org</option>
          {orgsSelectOptions}
        </Form.Control>
      </Form.Group>
    );
  }

  render() {
    const { show, orgs } = this.props;
    const { name } = this.state;
    return(
      <Modal
        size="lg"
        show={show}
        centered
        onHide={this.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add a new Dashboard</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={this.handleAddDashboard}>
            {this.showErrors()}
            <Form.Group>
              <Form.Label>Dashboard Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={name}
                onChange={this.handleFormChangeInput}
                placeholder="Example Dashboard Name"
                isInvalid={this.checkValueTypeHasError('name')}
              />
            </Form.Group>
            {orgs &&
              this.renderOrgSelect()
            }
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>Cancel</Button>
          <Button variant="primary" onClick={this.handleAddDashboard}>Add Dashboard</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ModalAddDashboard;
